import Configs from './Configs';

export default Configs;
